import React from 'react';
import PropTypes from 'prop-types';
import { CalculatorOutlined } from '@ant-design/icons';

import Colors from '../../../../../constants/Colors';
import OnTraccrButton from '../../../../../common/buttons/OnTraccrButton';
import { formatHours } from './redistributionHelpers';
import RedistributeHourBadge from './RedistributeHourBadge';

export default function RedistributeFooter({
  projectLabel,
  isEquipment,
  totals,
  onDone,
}) {
  const totalsContent = (
    <div className="ttg-redistribute-footer-totals">
      {!isEquipment && (
        <div className="ttg-redistribute-footer-hour-totals">
          <RedistributeHourBadge
            variant="REG"
            value={totals?.costCoded?.hours}
            valueStylePreset="footerTotal"
            containerClassName="ttg-redistribute-footer-total-cell"
          />
          <RedistributeHourBadge
            variant="OT"
            value={totals?.costCoded?.otHours}
            valueStylePreset="footerTotal"
            containerClassName="ttg-redistribute-footer-total-cell"
          />
          <RedistributeHourBadge
            variant="DT"
            value={totals?.costCoded?.doubleOTHours}
            valueStylePreset="footerTotal"
            containerClassName="ttg-redistribute-footer-total-cell"
          />
        </div>
      )}
      <div className="ttg-redistribute-footer-total-divider" />
      <div className="ttg-redistribute-footer-grand-total-cell">
        <span className="ttg-redistribute-footer-grand-total-label">Total</span>
        <span className="ttg-redistribute-footer-total-value">
          {formatHours(totals?.costCoded?.total)}
        </span>
      </div>
    </div>
  );

  const titleRow = (
    <div className="ttg-redistribute-footer-title-row">
      <CalculatorOutlined style={{ fontSize: 20, color: Colors.GRAY_700 }} />
      <span className="ttg-redistribute-footer-title">
        {projectLabel}
        {' '}
        Totals
      </span>
    </div>
  );

  const doneButton = (
    <OnTraccrButton
      title="Done"
      type="primary"
      className="ttg-redistribute-footer-done"
      onClick={onDone}
    />
  );

  return (
    <div className="ttg-redistribute-footer">
      <div className="ttg-redistribute-footer-done-container">{doneButton}</div>
      <div className="ttg-redistribute-footer-column-divider" />
      <div className="ttg-redistribute-footer-main">
        {titleRow}
        {totalsContent}
      </div>
    </div>
  );
}

RedistributeFooter.propTypes = {
  projectLabel: PropTypes.string.isRequired,
  isEquipment: PropTypes.bool.isRequired,
  totals: PropTypes.shape({
    costCoded: PropTypes.shape({
      hours: PropTypes.number,
      otHours: PropTypes.number,
      doubleOTHours: PropTypes.number,
      total: PropTypes.number,
    }),
  }).isRequired,
  onDone: PropTypes.func.isRequired,
};
